/* Slim sticky header — scroll show/hide + delegation to the real
   header's own cart/search controls (see gw-slim-header.liquid for why
   this never reimplements that logic itself). */
(function () {
  function init() {
  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bar = document.getElementById('gw-slim-header');
  if (!bar) return;

  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  var lastScrollY = window.scrollY;
  var ticking = false;
  var hideTimer = null;

  function getThreshold() {
    var fullHeader = document.querySelector('.gw-header-wrap') || document.getElementById('gw-header');
    if (!fullHeader) return 200;
    var rect = fullHeader.getBoundingClientRect();
    return rect.bottom + window.scrollY;
  }

  function show() {
    bar.classList.add('is-visible');
    bar.setAttribute('aria-hidden', 'false');
  }
  function hide() {
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
  }

  function onScroll() {
    var y = window.scrollY;
    var threshold = getThreshold();

    if (y <= threshold) {
      hide();
      lastScrollY = y;
      ticking = false;
      return;
    }

    if (isMobile) {
      if (y > lastScrollY) {
        hide(); // scrolling down
      } else {
        show(); // scrolling up
      }
    } else {
      show(); // desktop: stays visible once past the threshold
    }

    lastScrollY = y;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', function () {
    isMobile = window.matchMedia('(max-width: 749px)').matches;
  });

  // Search / cart: synthesize a click on the real header's own control,
  // so behaviour is always identical and nothing is reimplemented here.
  var searchBtn = bar.querySelector('[data-gw-slim-search]');
  if (searchBtn) {
    searchBtn.addEventListener('click', function () {
      var realToggle = document.querySelector('[data-gw-search-toggle]');
      if (realToggle) realToggle.click();
    });
  }
  var cartBtn = bar.querySelector('[data-gw-slim-cart]');
  if (cartBtn) {
    cartBtn.addEventListener('click', function () {
      var realCartIcon = document.getElementById('cart-icon-bubble');
      if (realCartIcon) realCartIcon.click();
    });
  }
  var wishlistBtn = bar.querySelector('[data-gw-slim-wishlist]');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function () {
      if (window.gwWishlist && window.gwWishlist.openDrawer) window.gwWishlist.openDrawer();
    });
  }

  // Wishlist badge count — independent listener (window.gwWishlist.onChange
  // supports multiple registered listeners), so the full header's own
  // badge logic in gw-wishlist.js never needs to know this bar exists.
  function updateWishlistBadge(count) {
    var bubble = document.getElementById('gw-slim-wishlist-count-bubble');
    var number = document.getElementById('gw-slim-wishlist-count-number');
    if (!bubble || !number) return;
    if (count > 0) {
      number.textContent = count > 99 ? '99+' : String(count);
      bubble.hidden = false;
    } else {
      bubble.hidden = true;
    }
  }
  if (window.gwWishlist) {
    window.gwWishlist.onChange(updateWishlistBadge);
    updateWishlistBadge(window.gwWishlist.count());
  }

  // Exposed for the flying-heart animation (gw-tarot-deck.js) to find
  // whichever wishlist icon is currently on screen and land on it.
  window.gwSlimHeader = {
    isVisible: function () { return bar.classList.contains('is-visible'); },
    getWishlistIconEl: function () { return wishlistBtn; },
    showTemporarily: function (ms) {
      show();
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        if (window.scrollY <= getThreshold()) { hide(); return; }
        if (isMobile) hide();
      }, ms || 2500);
    },
    bounceWishlistIcon: function () {
      if (!wishlistBtn) return;
      if (REDUCED_MOTION) return;
      wishlistBtn.classList.remove('is-bouncing');
      void wishlistBtn.offsetWidth;
      wishlistBtn.classList.add('is-bouncing');
    }
  };

  }

  /* Always wait for DOMContentLoaded rather than running immediately —
     this tag sits earlier in the DOM than theme.liquid's gw-wishlist.js
     in some layouts, both deferred; waiting for this event guarantees
     gw-wishlist.js has already run regardless of tag order (deferred
     scripts all finish, in document order, before DOMContentLoaded
     fires). Same reasoning as gw-tarot-deck.js. */
  document.addEventListener('DOMContentLoaded', init);
})();
